<template>
  <div class="px-8 pb-8">
    <div class="plans-toolbar">
      <div>
        <p class="toolbar-title mb-1">Alocações geradas</p>
        <p class="toolbar-subtitle mb-0">
          {{ plans.length }} alocação{{ plans.length == 1 ? "" : "ões" }}
          encontrada{{ plans.length == 1 ? "" : "s" }}
        </p>
      </div>
    </div>

    <div class="empty-card py-5 px-5" v-if="plans.length === 0">
      <p class="text-overline mb-1">Nenhuma alocação encontrada</p>
      <p class="text-body-2 mb-0">
        As alocações aparecerão aqui depois que forem geradas no simulador.
      </p>
    </div>

    <v-list v-else two-line class="plans-list">
      <template v-for="plan in plans">
        <v-list-item :key="plan.id" class="plan-item elevation-1">
          <v-list-item-avatar class="plan-avatar">
            <v-icon color="primary">
              mdi-calendar-check
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <template v-if="editingPlanId !== plan.id">
              <v-list-item-title class="font-weight-bold">
                {{ plan.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="plan-meta">
                {{ handleFormatDayAndTime(plan.date) }}
                <span class="meta-dot">•</span>
                {{ plan.numberClasses }} turmas
                <span class="meta-dot">•</span>
                {{ plan.numberRooms }} salas
              </v-list-item-subtitle>
              <p v-if="plan.queue" class="text-caption mb-0 muted-text">
                Esta alocação ainda está sendo gerada.
              </p>
            </template>
            <v-text-field
              v-else
              v-model="editingTitle"
              dense
              outlined
              hide-details
              maxlength="26"
              class="rename-field"
              @click.stop
              @keyup.enter="saveRename(plan)"
            ></v-text-field>
          </v-list-item-content>

          <v-list-item-action class="row-actions">
            <template v-if="editingPlanId === plan.id">
              <v-btn small color="primary" depressed @click="saveRename(plan)">
                Salvar
              </v-btn>
              <v-btn small text color="#5f6874" @click="cancelRename">
                Cancelar
              </v-btn>
            </template>
            <template v-else>
              <v-chip
                v-if="plan.queue"
                small
                color="amber lighten-5"
                text-color="#9a6500"
              >
                Processando
              </v-chip>
              <v-chip
                v-else-if="plan.share != 0"
                small
                color="blue lighten-5"
                text-color="primary"
              >
                Compartilhada
              </v-chip>
              <v-chip
                v-else
                small
                color="grey lighten-3"
                text-color="#506176"
              >
                Privada
              </v-chip>
              <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    :disabled="plan.queue"
                    aria-label="Mais opções"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="startRename(plan)">
                    <v-list-item-icon>
                      <v-icon small color="primary">
                        mdi-square-edit-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Renomear</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="confirmDelete(plan)">
                    <v-list-item-icon>
                      <v-icon small color="error">
                        mdi-delete-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="error--text">
                      Remover
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                small
                outlined
                color="primary"
                :disabled="plan.queue"
                @click="handleopen(plan)"
              >
                <v-icon small left>mdi-open-in-new</v-icon>
                Abrir
              </v-btn>
            </template>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import { updatePlan, deletePlan } from "@/api/paas/plans";
import { formatDayAndTime } from "@/utils/Format";

export default {
  name: "HandleDisplayPlans",
  props: {
    plans: Array,
    demo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editingPlanId: null,
      editingTitle: ""
    };
  },
  methods: {
    handleopen(_plan) {
      this.$router.push({
        path: `/paas/planos/${_plan.id}`,
        query: this.demo ? { demo: "1" } : {}
      });
    },
    startRename(plan) {
      this.editingPlanId = plan.id;
      this.editingTitle = plan.name;
    },
    cancelRename() {
      this.editingPlanId = null;
      this.editingTitle = "";
    },
    saveRename(plan) {
      const newTitle = this.editingTitle.trim();
      if (!newTitle) return;

      this.handleRename(plan, newTitle);
      this.cancelRename();
    },
    handleRename(_plan, _new_title) {
      let keep_old = _plan.name;
      _plan.name = _new_title;
      if (this.demo) return;

      updatePlan(_plan).catch(_ => {
        console.log(_);
        _plan.name = keep_old;
      });
    },
    handleFormatDayAndTime(_date) {
      return formatDayAndTime(_date);
    },
    confirmDelete(plan) {
      const confirmed = window.confirm(
        `Remover a alocação "${plan.name}"? Esta ação não pode ser desfeita.`
      );

      if (confirmed) this.handleDelete(plan);
    },
    handleDelete(_plan) {
      let idx = this.plans.findIndex(_ => _.id === _plan.id);
      this.plans.splice(idx, 1);
      if (this.demo) return;

      deletePlan(_plan).catch(_ => {
        console.log(_);
        this.plans.splice(idx, 0, _plan);
      });
    }
  }
};
</script>

<style scoped>
.plans-toolbar {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}

.toolbar-title {
  color: #1f2a37;
  font-size: 18px;
  font-weight: 800;
}

.toolbar-subtitle {
  color: #687385;
  font-size: 14px;
}

.empty-card {
  border: 1px solid #d7e4f2;
  border-radius: 8px;
}

.plans-list {
  background: transparent;
  padding: 0;
}

.plan-item {
  border: 1px solid #d7e4f2;
  border-radius: 8px;
  margin-bottom: 10px;
  min-height: 64px;
  padding-bottom: 6px;
  padding-top: 6px;
}

.plan-avatar {
  background: #e8f5ff;
  height: 36px !important;
  min-width: 36px !important;
  width: 36px !important;
}

.plan-meta {
  color: #687385 !important;
  margin-top: 4px;
}

.meta-dot {
  margin: 0 8px;
}

.rename-field {
  max-width: 320px;
}

.muted-text {
  color: #687385;
}

.row-actions {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
  margin-left: 16px;
}

@media only screen and (max-width: 860px) {
  .plan-item {
    align-items: flex-start;
    flex-wrap: wrap;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .row-actions {
    justify-content: flex-end;
    margin-left: 72px;
    margin-top: 8px;
    width: calc(100% - 72px);
  }
}
</style>
